import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ArrowRightFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM17.2204 11.9874C17.2204 12.1938 17.1302 12.3488 16.9618 12.5173L13.4409 16.0359C13.3207 16.1561 13.1697 16.2288 12.9682 16.2288C12.5943 16.2288 12.3183 15.9361 12.3183 15.5699C12.3183 15.377 12.3997 15.2046 12.5237 15.0844L13.9493 13.6756L15.189 12.5979L13.1752 12.6667H7.45476C7.05083 12.6667 6.76701 12.3788 6.76701 11.9913C6.76701 11.592 7.05473 11.308 7.45476 11.308H13.1752L15.1842 11.3808L13.9493 10.3078L12.5237 8.89038C12.4084 8.77018 12.3183 8.59773 12.3183 8.40483C12.3183 8.03859 12.5943 7.75468 12.9682 7.75468C13.1697 7.75468 13.3207 7.81867 13.4409 7.93887L16.9618 11.4661C17.1429 11.6473 17.2204 11.7975 17.2204 11.9874Z"
        fill={color}
      />
    </svg>
  );
};

export { ArrowRightFilledSvg };
